<template>
<!-- <div class="container-fluid mt--7"> -->
    <div class="row">
        <div class="col">  
                <b-modal v-if="convertedJson != null && convertedJson != ''" id="user-group-modal" size="xl">
                    <template slot="modal-header">Form Preview</template>
                    <template slot="default">
                        <dynamic-form :convertedJson="convertedJson" :key="refreshKey" ref="dynamicForm"></dynamic-form>
                    </template>
                    <template slot="modal-footer">
                      <b-button variant="default">
                          Cancel
                      </b-button>
                      <b-button variant="success" @click.prevent="validateForm">
                          Try Validation
                      </b-button>
                    </template>
                </b-modal> 
                
                <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="visible">
                    <div v-if="formId == 'addCategory'">
                        <h6 class="heading-small text-muted mb-4">Add Form</h6>  
                        <form>
                            <base-input alternative="" label="Name" placeholder="" v-model="selectedTitle" input-classes="form-control"/>
                            <base-input alternative="" label="Code" placeholder="" v-model="selectedCode" input-classes="form-control"/>
                            <base-input alternative="" label="Reference Code" placeholder="" v-model="selectedRefCode" input-classes="form-control"/>
                            <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                                <button class="btn btn-success" @click="createData">Create</button>
                                <button class="btn" @click.prevent="onClose">Cancel</button>
                            </div>
                        </form>
                    </div>
                    <div v-if="formId == 'editCategory'">
                        <h6 class="heading-small text-muted mb-4">Edit Form</h6>  
                        <form>
                            <base-input alternative="" label="Name" placeholder="" v-model="selectedTitle" input-classes="form-control"/>
                            <base-input alternative="" label="Code" placeholder="" v-model="selectedCode" input-classes="form-control"/>
                            <base-input alternative="" label="Reference Code" placeholder="" v-model="selectedRefCode" input-classes="form-control"/>
                            <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                                <button class="btn btn-success" @click="updateData">Update</button>
                                <button class="btn" @click.prevent="onClose">Cancel</button>
                            </div>
                        </form>
                    </div>
                </a-drawer>

                <div class="card mb-3" style="min-height: 60vh">
                  <div class="row no-gutters">
                    <div class="col-md-4" style="border-right: 1px solid #e0e0e0; min-height: 60vh">
                      <div class="card-body">
                        <div class="row">
                            <div class="col-md-12 no-gutters"><h2 class="card-title">Dynamic Forms</h2></div>
                        </div>
                        
                        <!-- <a-input style="margin-bottom: 8px" placeholder="Search Categories" @change="onChange" /> -->
                        <a-tree class="draggable-tree" :defaultExpandedKeys="expandedKeys" :expandedKeys="expandedKeys"
                          :autoExpandParent="autoExpandParent" draggable @expand="onExpand" @select="onSelect" 
                          :treeData="gData" ref="nodes" :showLine="defaultExpandAll">
                            <template slot="title" slot-scope="{title}">
                              <span v-if="title.indexOf(searchValue) > -1">
                                {{title.substr(0, title.indexOf(searchValue))}}
                                <span style="color: #f50">{{searchValue}}</span>
                                {{title.substr(title.indexOf(searchValue) + searchValue.length)}}
                              </span>
                              <span v-else>{{title}} </span>
                            </template>
                        </a-tree>

                        <br><br><br><br>
                       
                      </div>

                      <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                            <button  @click.prevent="showDrawer('addCategory')" type="button" class="btn btn-sm btn-primary float-right"> Add Form </button> 
                            <button v-if="selectedNode != null" @click.prevent="showDrawer('editCategory')" type="button" class="btn btn-sm btn-success float-right mr-2"> Edit </button> 
                            <button v-if="selectedNode != null" class="btn btn-sm mr-2 float-right btn-danger" @click.prevent="deleteData">Delete</button>
                      </div>
                    </div>
                    <div class="col-md-8" style="border-right: 1px solid #e0e0e0; min-height: 60vh;">
                        <div  class="card-body">
                            <a-tabs defaultActiveKey="1">
                                <a-tab-pane tab="Builder" key="1">
                                    <div class="row">
                                        <div class="col-md-8"><h2 class="card-title">Form Builder</h2></div>
                                        <div class="col-md-4 float-right"><button class="btn btn-sm btn-default" style="border-radius: 24px; border:0px; width: 100%;">Cheat Sheet</button></div>
                                    </div>
                                    <div v-if="selectedNode != null" class="row" style="overflow:scroll;">
                                        <div class="col-md-12">
                                            <base-input alternative="">
                                                <textarea v-model="jsonField" rows="20" class="form-control" />
                                            </base-input>
                                        </div>
                                    </div>
                                    <div v-else class="row col-md-12" style="overflow:scroll;">
                                        <small>Please select a form</small>
                                    </div>

                                    <br><br><br><br>
                                </a-tab-pane>
                                <a-tab-pane tab="JSON Viewer" key="2">
                                    <div class="row col-md-12"> 
                                        <vue-json-pretty
                                          :data="JSON.parse(convertedJson)">
                                        </vue-json-pretty>
                                    </div>
                                </a-tab-pane>
                            </a-tabs>
                            

                        </div>

                        <div v-if="selectedNode != null" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                            <button type="button" class="btn btn-sm btn-primary float-right" v-b-modal.user-group-modal @click="refreshKey++"> Preview </button> 
                            <button type="button" class="btn btn-sm btn-success mr-2 float-right" @click.prevent="updateTemplate"> Save </button> 
                        </div>
                    </div>

                  </div>
                </div>
        </div>
    </div>
</template>

<script>
import HTTPRequest from '../controllers/httpRequest.js'
import DynamicForm from './DynamicForm.vue' 
import { mapState, mapActions } from 'vuex'


var ObjGen = require('../../node_modules/objgen/objgen.js').ObjGen;

// console.log(json);

let gData = []
const dataList = []
const generateList = (data) => {
  for (let i = 0; i < data.length; i++) {
    const node = data[i]
    const key = node.key
    dataList.push({ key, title: node.title })
    if (node.children) {
      generateList(node.children, node.key)
    }
  }
}

const getParentKey = (key, tree) => {
  let parentKey
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    if (node.children) {
      if (node.children.some(item => item.key === key)) {
        parentKey = node.key
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children)
      }
    }
  }
  return parentKey
}

let node_ret = null
const getNode = function (key, tree)
{
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    if(node.key == key){
       node_ret = node 
    } else {
       if(node.children != undefined){
          if(node.children.length > 0){
            getNode(key, node.children)
          }
       }
    }
  }
  return node_ret;
}

import VueJsonPretty from 'vue-json-pretty'

// var conditionResult = []

export default {
    components: {
        VueJsonPretty,
        DynamicForm
    },
  mounted: async function(){  
    this.gData = await HTTPRequest.getRequest(this.endPoint + '/dynamic_forms/tree_view', null)    
    gData = this.gData
    generateList(gData)
  },
  computed: {
       ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        // ...mapState(['endPoint', 'currentProfile', 'parameters', 'serverType']
    },
  data () {
    return {
      formSettings: {},
      defaultExpandAll: true,
      refreshKey: 0,
      convertedJson: null,
      jsonField: "",
      licenseStats: "",
      componentKey: 0,
      filterStatus: "",
      checkedValues: [],
      expandedKeys: [],
      searchValue: '',
      autoExpandParent: true,
      gData,
      visible: false,
      formId: "",
      selectedNode: null,
      selectedKey: null,
      selectedTitle: "",
      selectedCode: "",
      selectedRefCode: "",
      selectedProfile: "system_modules",
    //   serverType: "ho"
    }
  },
  watch: {
      selectedProfile: async function(){
        if (this.selectedProfile == "terminals") {
            var stats = await HTTPRequest.getRequest(this.endPoint + "licenses/get_stats" , null)  
            this.licenseStats =  stats["active_license"] +  "/" +  stats["no_of_license"]
        }
      },
      jsonField: function() {
          if(this.jsonField != null)
            this.convertedJson = ObjGen.xJson(this.jsonField, {numSpaces: 2})
          else
            this.convertedJson = null
      }
  },
  methods: { 
    validateForm(){
      this.$refs.dynamicForm.validateForm()
    },
    // !!! START - DRAWERS
    showDrawer(formId) {
        this.formId = formId
        if(formId == 'addCategory'){
            this.clearData()
            this.visible = true
        } else {
            this.visible = true
        }
    },
    onClose() {
      this.visible = false
    },
    async createData(){
        if(this.selectedNode == null){
            this.selectedKey = null
        }
        var categoryPayload = {dynamic_form: {profile_name: this.selectedTitle, code: this.selectedCode, reference_code: this.selectedRefCode, status: 'A', parent_id: this.selectedKey} }
        this.gData = await HTTPRequest.postRequest(this.endPoint + 'dynamic_forms/' , null, categoryPayload)   
        gData = this.gData
        generateList(gData)
        alert("Create Successful")
        this.clearData()
        this.onClose()
    },
    async updateData(){
        var categoryPayload = {dynamic_form: {profile_name: this.selectedTitle, code: this.selectedCode, reference_code: this.selectedRefCode} }
        this.gData = await HTTPRequest.putRequest(this.endPoint + 'dynamic_forms/' + this.selectedKey , null, categoryPayload)   
        gData = this.gData
        generateList(gData)
        //this.clearData()
        alert("Update Successful")
        this.onClose()
    },
    async deleteData(){
        var categoryPayload = {dynamic_form: {status: "D"} }
        this.gData = await HTTPRequest.putRequest(this.endPoint + 'dynamic_forms/' + this.selectedKey , null, categoryPayload)   
        gData = this.gData
        generateList(gData)
        this.clearData()
        alert("Delete Successful")
        this.onClose()
    },
     async updateTemplate(){
        var categoryPayload = {dynamic_form: {template: this.jsonField} }
        this.gData = await HTTPRequest.putRequest(this.endPoint + 'dynamic_forms/' + this.selectedKey , null, categoryPayload)   
        gData = this.gData
        generateList(gData)
        this.clearData()
        alert("Update Successful")
        this.onClose()
    },
    // !!! END - DRAWERS

     refreshPage(){
        this.visible = false
        this.componentKey++    
     },
    clearData(){
        //this.selectedKey = null
        this.selectedCode = null
        this.selectedRefCode = null
        this.selectedTitle = null
    },
    
    // TREE FUNCTIONS
    onExpand  (expandedKeys) {
      this.selectedNode = null
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    onChange (e) {
      const value = e.target.value
      const expandedKeys = dataList.map((item) => {
        if (item.title.indexOf(value) > -1) {
          return getParentKey(item.key, gData)
        }
        return null
      }).filter((item, i, self) => item && self.indexOf(item) === i)
      Object.assign(this, {
        expandedKeys,
        searchValue: value,
        autoExpandParent: true,
      })
    },
    async onSelect(info){
        // console.log("******")
        // console.log(this.gData)
        var selectedNode = getNode(info[0], this.gData)
        this.selectedNode = selectedNode
        this.selectedKey = selectedNode.key
        this.selectedCode = selectedNode.scopedSlots.code
        this.selectedRefCode = selectedNode.scopedSlots.reference_code
        this.selectedTitle = selectedNode.title
        this.jsonField = selectedNode.scopedSlots.settings_template
    },
    ...mapActions(['updateCurrentProfile', 'updateParameters']),
    setCurrentProfile(profile){
        this.selectedProfile = profile
        if(profile == "terminals" || profile == "payment_types"){
            this.updateCurrentProfile(profile)
        } 
    },
    changeFilter(statusFilter, searchFilter, searchText){
    //   console.log(statusFilter)
      this.filterStatus = statusFilter
      if(statusFilter == "0"){
          // console.log(this.parameters)
          this.updateParameters("?" + searchFilter + "=" + searchText)
          // console.log(this.parameters)
      } else if( statusFilter == "A"){
          this.updateParameters("?" + searchFilter + "=" + searchText + "&status=A")
      } else { 
          this.updateParameters("?" + searchFilter + "=" + searchText + "&status=I")
      }
    
    },
  },
}
</script>

<style scoped>
</style>


